module.exports = __webpack_public_path__ + "static/media/home-screen-banner.daff51d3.jpg";